import * as React from "react";

import ClassNames from "classnames";

import ButtonIcon from "../ButtonIcon";
import Typography from "../Typography";

import IconClose from "../_assets/icon-close.svg";
import IconError from "../_assets/icon-warning-triangle.svg";

import IconInfo from "../_assets/icon-info.svg";
import IconSuccess from "../_assets/icon-success-circle.svg";
import Styles from "./AlertMessage.module.css";

export interface Props {
  className?: string;
  alertMessage?: string;
  id?: string;
  variant?: "success" | "error" | "informational";
  dismissable?: boolean;
}

const AlertMessage: React.FC<Props> = props => {
  const { className, id, alertMessage, variant, dismissable = false } = props;
  const [alert, setAlert] = React.useState(true);
  const handleDismiss = () => {
    setAlert(false);
  };

  return (
    <>
      {alert && (
        <div id={id}>
          <div
            className={ClassNames({
              [`${Styles.alert} ${Styles[variant]}`]: true,
              [className]: className
            })}
          >
            {variant === "success" ? (
              <IconSuccess is="svg" />
            ) : variant === "error" ? (
              <IconError is="svg" />
            ) : variant === "informational" ? (
              <IconInfo is="svg" />
            ) : null}
            <Typography
              className={ClassNames({
                [`${Styles[variant]}`]: true,
                [Styles.dismiss]: dismissable !== false
              })}
              variant="p"
            >
              {alertMessage}
            </Typography>
            {dismissable && (
              <span className={Styles.alertButton}>
                <ButtonIcon
                  label="Dismiss message"
                  aria-label="Close"
                  variant="text"
                  onClick={handleDismiss}
                  shape="square"
                  icon={<IconClose is="svg" />}
                />
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AlertMessage;
